import { AccountData } from '../service/AccountData';

export class Action {

  run() {
    new AccountData(this.context);
  }
}
